import { connect, ConnectedProps, useSelector } from "react-redux";
import React, { useRef } from "react";

import { figures } from "../../../../assets/images/races";

import avatar from "../../../../assets/images/avatar-temp.png";
import { GovernyInfo } from "../../../../lib/types";
import { formatNumber } from "../../../../lib/commonFunctions";
import { cancelApplication, openContentPopup, openDialog } from "../../../../store/actions";
import GovernorateInfoLink from "../../../Common/GovernorateInfoLink";
import AllianceInfoLink from "../../../Common/AllianceInfoLink";
import { DragescentState } from "../../../../store/reducers/stateType";

interface IProps {
  governorate: Pick<GovernyInfo, "id" | "name" | "race" | "note" | "alliance" | "landPosition" | "land" | "powerPosition" | "power" | "ljp" | "rating" | "lastAction">;
  owner: boolean;
  player: any;
  war?: boolean;
  membershipApplicationName?: string;
}

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  cancelApplicationDispatch: (governorateId: number) => dispatch(cancelApplication(governorateId)),
  openContentPopupDispatch:
    (contentPopupOptions: any) => dispatch(openContentPopup(contentPopupOptions))
})

const connector = connect(null, mapDispatchToProps)

const GovernorateProfile = ({
  governorate,
  owner,
  player,
  war,
  membershipApplicationName,
  openDialogDispatch,
  openContentPopupDispatch,
  cancelApplicationDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const actionsButtonRef = useRef<HTMLAnchorElement>(null);
  const abdicationButtonRef = useRef<HTMLAnchorElement>(null);
  const editNoteRef = useRef<HTMLAnchorElement>(null);

  const id = useSelector((state: DragescentState) => state.governorate.id);
  const alliance = useSelector((state: DragescentState) => state.governorate.alliance);

  return (
    <>
      <section className="boxes-group">
        <div className="box first padding">
          <div className="row">
            <div className="col-sm-4 col-md-6">
              <div>
                <img src={figures[governorate.race.name]} alt={"race portrait"}/>
              </div>
            </div>
            <div className="col-sm-8 col-md-6">
              <table className="table table-hover">
                <tbody>
                <tr>
                  <td><strong>Land</strong></td>
                  <td>
                    {governorate.landPosition === 1
                      ? <strong><em>{governorate.land}</em></strong>
                      : <>{governorate.land}</>
                    }
                  </td>
                  <td className="text-right">
                    {governorate.landPosition === 1
                      ? <strong><em>{governorate.landPosition}. position</em></strong>
                      : <>{governorate.landPosition}. position</>
                    }
                  </td>
                </tr>
                <tr>
                  <td><strong>Power</strong></td>
                  <td>
                    {governorate.powerPosition === 1
                      ? <strong><em>{governorate.power}</em></strong>
                      : <>{governorate.power}</>
                    }
                  </td>
                  <td className="text-right">
                    {governorate.powerPosition === 1
                      ? <strong><em>{governorate.powerPosition}. position</em></strong>
                      : <>{governorate.powerPosition}. position</>
                    }
                  </td>
                </tr>
                <tr>
                  <td><strong>Race</strong></td>
                  <td colSpan={2}>
                    {governorate.race.name}
                  </td>
                </tr>
                <tr id="gov-profile-coal">
                  <td><strong>Alliance</strong></td>
                  <td className="js-alliance-name">
                    {governorate.alliance
                      ? <AllianceInfoLink
                          name={governorate.alliance.name}
                          allianceId={governorate.alliance.id}
                      />
                      : <>Non-alliance</>
                    }
                  </td>
                  {owner ? <td className="text-right">
                    <a
                      href="#"
                      ref={actionsButtonRef}
                      onClick={() => !war && openDialogDispatch({
                        name: "AllianceActions",
                        header: governorate.alliance ? "Leave the alliance" : "Join the alliance",
                        elementRef: actionsButtonRef.current
                      })}
                      className={`btn btn-sm btn-blank btn-no-width ${war ? "disabled" : ""}`}
                    >
                      Actions
                    </a>
                  </td> : <></>}
                </tr>

                {membershipApplicationName
                  ? <tr className="no-border js-coal-application">
                    <td colSpan={2}>
                      <span className="text info">
                        You have applied to alliance <a href="#" className="grey">{membershipApplicationName}</a>
                      </span>
                    </td>
                    <td className="text-right">
                      <a
                        href="#"
                        onClick={() => cancelApplicationDispatch(governorate.id)}
                        className="btn btn-sm btn-blank btn-no-width"
                      >
                        Cancel
                      </a>
                    </td>
                  </tr> : <></>
                }

                <tr>
                  <td><strong>LJP Points</strong></td>
                  <td>{formatNumber(governorate.ljp)}</td>
                </tr>
                <tr>
                  <td><strong>Rating</strong></td>
                  <td>{formatNumber(governorate.rating)}</td>
                </tr>
                <tr>
                  <td><strong>Last action</strong></td>
                  <td colSpan={2}>
                    {governorate.lastAction || "-"}
                  </td>
                </tr>
                </tbody>
              </table>
              {!owner
                ? <p className="text-center">
                  <a
                    className="btn btn-blank btn-no-width"
                    onClick={() => openContentPopupDispatch({
                      name: "Mail",
                      title: "Mail",
                      icon: "posta",
                      presetRecipient: governorate.name
                    })}
                  >
                    Send message
                  </a>
                </p>
                : <div className="row">
                  {!war && <div className="col-sm-12">
                    <a
                      ref={abdicationButtonRef}
                      className={`btn btn-sm btn-blank btn-no-width ${war ? "disabled" : ""}`}
                      onClick={() => openDialogDispatch({
                        name: "Abdication",
                        header: "Abdication",
                        elementRef: abdicationButtonRef.current
                      })}
                    >
                      Abdicate governy
                    </a>
                  </div>}
                </div>
              }
              {owner || governorate.note
                ? <div className="row">
                  <div className="motto-wrap col-md-12">
                    <blockquote className="motto">{governorate.note}</blockquote>
                    {owner
                      ? <a ref={editNoteRef} className="link" onClick={() => openDialogDispatch({
                        name: "EditNote",
                        header: "Personal note",
                        elementRef: editNoteRef.current,
                        note: governorate.note,
                        type: "governorate"
                      })}>
                        {`${governorate.note ? "Edit" : "Add own"} message`}</a> : <></>
                    }
                  </div>
                </div> : <></>}
              <div className={"scrollable"}>
              <table className="table table-hover vertical-top">
                <tbody className="no-border">
                <tr>
                  <td><strong>Player</strong></td>
                  <td colSpan={2}>
                    <img src={avatar} alt="" className="avatar-icon"/>
                    <a href="#account-info-{{ gov.player.id }}" className="white"
                       data-toggle="dialog"><strong>{player.name}</strong></a>
                  </td>
                </tr>
                <tr>
                  <th className="text-center" colSpan={3}>
                    Player's governorates
                  </th>
                </tr>
                <tr>
                  <th><em>Governorate</em></th>
                  <th><em>Alliance</em></th>
                  <th><em>Activity</em></th>
                </tr>
                {player.governorates.map((g: GovernyInfo) => (
                    <tr>
                      <td className="slim">
                        <GovernorateInfoLink govId={g.id} name={g.name} raceName={g.race.name}/>
                      </td>
                      <td className="slim">
                        {(g.id === id && alliance) || (g.id !== id && g.alliance)
                          ? <i>
                            <AllianceInfoLink
                              name={g.id === id && alliance
                                ? alliance.name : (g.alliance ? g.alliance.name : "")}
                              allianceId={g.id === id && alliance
                                ? alliance.id : (g.alliance ? g.alliance.id : 0)}
                            />
                          </i>
                          : <i>Non-alliance</i>
                        }
                      </td>
                      <td
                        className="slim" style={{ whiteSpace: "nowrap" }}>{g.lastAction ? governorate.lastAction : "-"}</td>
                    </tr>))
                }
                </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
        <span className="divider"/>
      </section>
    </>
  )
}

export default connector(GovernorateProfile);
